import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ReceivementOverviewListState'
import { useCallback, useEffect, useMemo } from 'react'
import { SelectMui } from 'src/components/SelectMui'

export const SupplierFilterSelect = () => {
  const dispatch = useDispatch()
  const { idSupplier, suppliers } = useSelector((state) => state.receivementOverviewList)

  useEffect(() => {
    dispatch(actions.getFilterSuppliers())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const suppliersOptions = useMemo(() => suppliers?.map((s) => (
    {
      id: s.id,
      description: s.name,
    }
  )), [suppliers])

  const setSelectedSupplier = useCallback((value: string) => {
    dispatch(actions.updateOverviewFilterField({ key: 'idSupplier', value }))
  }, [dispatch])

  return (
    <SelectMui
      label='Fornecedor'
      options={suppliersOptions || []}
      value={idSupplier || ''}
      onChange={(event: any) => setSelectedSupplier(event.target.value as string)}
      searchBar
      searchBarDataTestId='supplier-filter-select-search-bar-test-id'
      renderAfterInputSearchBar
      maxHeight='600px'
    />
  )
}
